"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionRestorer = void 0;
var rich_utils_1 = require("../../model/rich-utils");
var list_1 = require("@devexpress/utils/lib/utils/list");
var run_type_1 = require("../../model/runs/run-type");
var simple_runs_1 = require("../../model/runs/simple-runs");
var SectionRestorer = (function () {
    function SectionRestorer() {
    }
    SectionRestorer.fixLastSection = function (model) {
        var lastSection = list_1.ListUtils.last(model.sections);
        if (!lastSection.interval.length) {
            model.sections.pop();
            var chunk = model.mainSubDocument.getLastChunk();
            var textRuns = chunk.textRuns;
            var lastRun = list_1.ListUtils.last(textRuns);
            if (lastRun.getType() == run_type_1.RunType.SectionRun) {
                var startOffset = lastRun.startOffset;
                var paragraphMark = rich_utils_1.RichUtils.specialCharacters.ParagraphMark;
                chunk.textBuffer = [chunk.textBuffer.substr(0, startOffset), paragraphMark].join('');
                textRuns.pop();
                lastRun.paragraph.listLevelIndex = Math.max(0, lastRun.paragraph.listLevelIndex);
                textRuns.push(new simple_runs_1.ParagraphRun(startOffset, lastRun.paragraph, lastRun.getCharPropsBundle(model)));
            }
        }
    };
    return SectionRestorer;
}());
exports.SectionRestorer = SectionRestorer;
